export const getProducts = (products = [], category, type, limit) => {
  let finalProducts = [];

  if (category) {
    finalProducts = products.filter(product =>
      Array.isArray(product.categories) &&
      product.categories.some(
        cat => cat.slug === category || cat.name === category
      )
    );
  } else {
    finalProducts = products;
  }

  if (type === "new") {
    const newProducts = finalProducts.filter(single => single.is_new);
    return newProducts.slice(0, limit || newProducts.length);
  }

  if (type === "saleItems") {
    const saleItems = finalProducts.filter(
      single => single.discount_percent && single.discount_percent > 0
    );
    return saleItems.slice(0, limit || saleItems.length);
  }

  if (type === "bestSeller") {
    return finalProducts
      .sort((a, b) => (b.saleCount || 0) - (a.saleCount || 0))
      .slice(0, limit || finalProducts.length);
  }

  return finalProducts.slice(0, limit || finalProducts.length);
};

export const getDiscountPrice = (price, discount_percent) => {
  return discount_percent && discount_percent > 0
    ? price - price * (discount_percent / 100)
    : null;
};

export const getProductCartQuantity = (cartItems, product, color, size) => {
  if (!cartItems || !Array.isArray(cartItems)) return 0;

  const productInCart = cartItems.find(
    single =>
      single.id === product.id &&
      (!color || single.selectedProductColor === color) &&
      (!size || single.selectedProductSize === size)
  );

  return productInCart ? productInCart.quantity : 0;
};

export const cartItemStock = (item, color, size) => {
  if (item.stock) return item.stock;

  if (!item.variants || !Array.isArray(item.variants)) return 0;

  const variant = item.variants.find(
    v =>
      (!color || v.color === color) &&
      (!size || v.size === size)
  );

  return variant ? variant.stock : 0;
};

export const getSortedProducts = (products = [], sortType, sortValue) => {
  if (sortType && sortValue) {
    // === фильтрация по категории / тегу ===
    if (sortType === "category") {
      return products.filter(p =>
        Array.isArray(p.categories) &&
        p.categories.some(cat => cat.slug === sortValue || cat.name === sortValue)
      );
    }

    if (sortType === "tag") {
      return products.filter(p =>
        Array.isArray(p.tags) &&
        p.tags.some(t =>
          typeof t === "object"
            ? t.slug === sortValue || t.name === sortValue
            : t === sortValue
        )
      );
    }

    if (sortType === "filterSort") {
      const sorted = [...products];
      switch (sortValue) {
        case "priceHighToLow":
          return sorted.sort((a, b) => b.price - a.price);
        case "priceLowToHigh":
          return sorted.sort((a, b) => a.price - b.price);
        case "newest":
          return sorted.sort((a, b) => new Date(b.created) - new Date(a.created));
        case "bestSeller":
          return sorted.sort((a, b) => (b.saleCount || 0) - (a.saleCount || 0));
        case "onSale":
          return sorted.filter(p => p.discount_percent && p.discount_percent > 0);
        case "new":
          return sorted.filter(p => p.is_new);
        case "random":
          return sorted.sort(() => Math.random() - 0.5);
        default:
          return sorted;
      }
    }
  }

  return products;
};

const getUnique = array => [...new Set(array.filter(Boolean))];

export const getIndividualCategories = products => {
  if (!products || products.length === 0) return [];
  const all = products.flatMap(p =>
    p.categories?.map(c => (typeof c === "object" ? c.name : c)) || []
  );
  return getUnique(all);
};

export const getIndividualTags = products => {
  if (!products || products.length === 0) return [];
  const all = products.flatMap(p =>
    p.tags?.map(t => (typeof t === "object" ? t.name : t)) || []
  );
  return getUnique(all);
};

export const getIndividualColors = products => {
  if (!products || products.length === 0) return [];
  const all = products.flatMap(p => p.variants?.map(v => v.color) || []);
  return getUnique(all);
};

export const getProductsIndividualSizes = products => {
  if (!products || products.length === 0) return [];
  const all = products.flatMap(p => p.variants?.map(v => v.size) || []);
  return getUnique(all);
};

export const getIndividualSizes = product => {
  if (!product.variants) return [];
  const all = product.variants.map(v => v.size);
  return getUnique(all);
};

export const setActiveSort = e => {
  document
    .querySelectorAll(
      ".sidebar-widget-list-left button, .sidebar-widget-tag button, .product-filter button"
    )
    .forEach(item => item.classList.remove("active"));

  e.currentTarget.classList.add("active");
};

export const setActiveLayout = e => {
  document
    .querySelectorAll(".shop-tab button")
    .forEach(item => item.classList.remove("active"));
  e.currentTarget.classList.add("active");
};

export const toggleShopTopFilter = e => {
  const wrapper = document.querySelector("#product-filter-wrapper");
  if (!wrapper) return;
  wrapper.classList.toggle("active");
  wrapper.style.height = wrapper.style.height ? null : `${wrapper.scrollHeight}px`;
  e.currentTarget.classList.toggle("active");
};
